
class PreparePaymentDetailsResponse {
    public emailText: string;
    public totalPrice: number;
}

export default PreparePaymentDetailsResponse;


// WEBPACK FOOTER //
// ./src/services/response/PreparePaymentDetailsResponse.tsx